import _regeneratorRuntime from "/builds/telematics/zuul/web/prebooking-ui/node_modules/@babel/runtime/regenerator/index.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

function setupSharedTokenCallback(window, callback) {
  if (!window.app) {
    window.app = {
      setToken: callback,
      safeAreaTopInset: 0
    };
  }

  window.app.setToken = callback;
}

function refreshSharedToken(window) {
  return window.android && window.android.refreshAuthToken() || window.webkit && window.webkit.messageHandlers.refreshAuthToken.postMessage("");
}

export function closeWebview(window) {
  return window.android && window.android.close() || window.webkit && window.webkit.messageHandlers.close.postMessage("");
}

function displayCloseButtonAndroid(window) {
  var _a;

  return (_a = window === null || window === void 0 ? void 0 : window.android) === null || _a === void 0 ? void 0 : _a.clearHistory();
}

function displayCloseButtonIOS(window) {
  var _a, _b, _c;

  return (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.setWebviewCloseable) === null || _c === void 0 ? void 0 : _c.postMessage("");
}

export function displayCloseButton(window) {
  displayCloseButtonAndroid(window) || displayCloseButtonIOS(window);
}

function checkWebviewHistory(window) {
  return window.android && window.android.checkHistory && window.android.checkHistory();
}

function navigateForward(window) {
  return window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.didNavigateForward.postMessage("");
}

export function displayBackButton(window) {
  checkWebviewHistory(window) || navigateForward(window);
}
export function getToken(window) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(sessionStorage && sessionStorage.getItem("jwt"))) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", Promise.resolve(String(sessionStorage.getItem("jwt"))));

          case 2:
            return _context.abrupt("return", new Promise(function (resolve) {
              setupSharedTokenCallback(window, resolve);
              refreshSharedToken(window);
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}
export function getSafeAreaTopInset(window) {
  if (window.android && window.android.safeAreaTopInset) return window.android.safeAreaTopInset();
  if (window.app && window.app.safeAreaTopInset) return window.app.safeAreaTopInset;
  return 0;
}
export function fireAppsflyerEvent(window, eventName) {
  var stringifiedParams = JSON.stringify({
    eventName: eventName
  });
  window.android && window.android.recordAttributionEvent && window.android.recordAttributionEvent(stringifiedParams) || window.webkit && window.webkit.messageHandlers.recordAttributionEvent && window.webkit.messageHandlers.recordAttributionEvent.postMessage({
    eventName: eventName
  });
}
export function isInAppContext(window) {
  return window.hasOwnProperty("webkit") || window.hasOwnProperty("android");
}
export function closeStationPanel(window) {
  var _a, _b, _c, _d;

  (_b = (_a = window.android) === null || _a === void 0 ? void 0 : _a.closeStationPanel) === null || _b === void 0 ? void 0 : _b.call(_a);
  (_d = (_c = window.webkit) === null || _c === void 0 ? void 0 : _c.messageHandlers.closeStationPanel) === null || _d === void 0 ? void 0 : _d.postMessage("");
} // when there are multiple api request, there is a race condition for getToken
// retrying getToken will solve the problem

var getTokenWithTimeout = function getTokenWithTimeout(timeout) {
  return new Promise(function (resolve, reject) {
    var timer = setTimeout(function () {
      reject("get jwt timed out");
    }, timeout);
    getToken(window).then(function (jwt) {
      clearTimeout(timer);
      resolve(jwt);
    }).catch(function (error) {
      clearTimeout(timer);
      reject(error);
    });
  });
};

export var getJwt = function getJwt() {
  var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 200;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return getTokenWithTimeout(timeout);

          case 3:
            return _context2.abrupt("return", _context2.sent);

          case 6:
            _context2.prev = 6;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", getJwt(timeout * 2));

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 6]]);
  }));
};